import Cart from '@/components/Pages/Cart'
import Checkout from '@/components/Pages/Checkout.vue'
import OrderTracking from '@/components/Pages/TrackOrder'

// profile start
import Catalog from '@/components/Pages/Catalog'
import ProductLandingPage from '@/components/Blocks/ProductLandingPage'

var routes = [
  /*delivery area and updated url*/
  {
    path: '/store/:store_id/:delivery_area?',
    name: 'brand_store_page',
    component: Catalog,
    meta: {
      title: 'Catalog page',
    },
  },
  {
    path: '/:store_id/:order_id/track-order/:delivery_area?',
    name: 'brand_track-order',
    component: OrderTracking,
    meta: {
      title: 'Order tracking',
    },
  },
  {
    path: '/category/:category_name/:delivery_area?',
    name: 'brand_store_page_category',
    component: Catalog,
    meta: {
      title: 'Catalog category page',
    },
  },
  {
    path: '/:store_id?/product/:product_id/:delivery_area?',
    name: 'product_landing_page',
    component: ProductLandingPage,
    meta: {
      data: {},
      title: 'Product Page',
    },
  },
  {
    path: '/category/:category_name/product/:product_id/:delivery_area?',
    name: 'category_product_landing_page',
    component: Catalog,
    meta: {
      data: {},
      title: 'Product Page',
    },
  },
  {
    path: '/cart',
    name: 'brand_cart',
    component: Cart,
    meta: {
      data: {},
      title: 'Cart',
    },
  },

  {
    path: '/:store_id/checkout',
    name: 'brand_checkout',
    component: Checkout,
    meta: {
      data: {},
      title: 'Checkout',
    },
  },
]
export default routes
